import { lazy } from 'react'
import { RouteObject } from 'react-router-dom'
import { Tenant360Provider } from '../context/Tenant360Context'

const LandingPage = lazy(
    () => import('../components/LandingPage')
)
const SubscriptionManagementPage = lazy(
    () => import('../components/SubscriptionManagementPage')
)
const BillingPage = lazy(
    () => import('../components/BillingPage')
)

export const Tenant360Routes: RouteObject = {
    path: 'tenants/:tenantId',
    element: <Tenant360Provider />,
    children: [
        { index: true, element: <LandingPage /> },
        { path: 'subscription', element: <SubscriptionManagementPage /> },
        { path: 'subscription/:subscriptionId/billing', element: <BillingPage /> },
    ],
}
